import type { PaginatedResponse } from '@/types/responses';

export const MAX_PAGE_SIZE = 100;
const CONCURRENT_PAGE_REQUESTS = 4;

export async function fetchAllPages<T>(
    fetchPage: (params: {
        page: number;
        size: number;
    }) => Promise<PaginatedResponse<T>>,
): Promise<T[]> {
    const firstPage = await fetchPage({ page: 1, size: MAX_PAGE_SIZE });
    const { totalPages } = firstPage.page;
    const items = [...firstPage.items];
    for (
        let batchStart = 2;
        batchStart <= totalPages;
        batchStart += CONCURRENT_PAGE_REQUESTS
    ) {
        const batchEnd = Math.min(
            batchStart + CONCURRENT_PAGE_REQUESTS - 1,
            totalPages,
        );
        const batch = await Promise.all(
            Array.from({ length: batchEnd - batchStart + 1 }, (_, index) =>
                fetchPage({ page: batchStart + index, size: MAX_PAGE_SIZE }),
            ),
        );
        batch.forEach((response) => items.push(...response.items));
    }
    return items;
}
